import React, { Component } from 'react';
import { Grid, Image, Header, Form, Button, Message, Segment, Label } from 'semantic-ui-react'
import Select from 'react-select';
import { ShirtSizesRadioGroup, ShirtColorsRadioGroup, ShirtTypeRadioGroup, ErrorMessages } from './OrderFormComps'
import ImageUploader from './ImageUploader'
import SizeAndQtyFields from './SizeAndQtyFields'
import { getSingleOrderObject, getSingleOrderArray } from '../../config/SingleOrderUtils.js'
import { SingleOrderFromArray } from './SingleOrderFromArray/SingleOrderFromArray';
import SetOrderType from '../dashBoard/newDashboard/SetOrderType/SetOrderType';
import SetOrderTypeOnOrderEntry from '../dashBoard/newDashboard/SetOrderType/SetOrderTypeOnOrderEntry';


/**
 * RENDERS THE ORDER FORM
 * @param {*} props 
 */
export default function OrderFormUI(props) {
    console.log("itemSelected:" + props.itemSelected);
    /**
     * SHOW IMAGE UPLOAD
     */
    const imageUpload = props.itemSelected === 't-shirts' || props.itemSelected === 'jumper' || props.itemSelected === 'cup'
        ? <div>
            <br />
            <label>Would you like to upload an image for your item </label>
            <ImageUploader
                updateWhenFileUploadComplete={props.updateWhenFileUploadComplete}
                storageReference={'orderDesigns'} />
            {imagePreview}
        </div>
        : (<p></p>)

    /**
     * SHOWS IMAGE PREVIEW OF WHAT'S BEEN UPLOADED
     */
    const imagePreview = props.imageUrl != 'none' && (props.itemSelected === 't-shirts' || props.itemSelected === 'jumper' || props.itemSelected === 'cup')
        ? (<Image src={props.imageUrl} size='small' centered bordered shape='rounded' />)
        : (<p></p>)


    /**
     * WORDS ON SHIRTS - NOT SHOW ON CRANES OR EPL JERSEYS..
     */
    const wordsOnShirt = props.itemSelected !== 'cranes' && props.itemSelected !== 'football'
        ? <Form.Field>
            <label>{props.wordsOnItemLabel}</label>
            <Form.Input
                fluid
                name={'shirtText'}
                value={props.shirtText}
                icon='sort alphabet ascending'
                iconPosition='left'
                placeholder='Text on your item'
                onFocus={props.amp_logFieldClick}
                onChange={props.handleTextInputChange}
            />
        </Form.Field>
        : ''


    /**
    * WORDS ON SHIRTS - NOT SHOW ON CRANES OR EPL JERSEYS..
    */
    const wordsOnBackOfshirt = props.itemSelected !== 'cranes' && props.itemSelected !== 'football' && props.itemSelected !== 'cup'
        ? <Form.Field>
            <label>{props.wordsOnBackItemLabel}</label>
            <Form.Input
                fluid
                name={'shirtBackText'}
                value={props.shirtBackText}
                icon='sort alphabet ascending'
                iconPosition='left'
                placeholder='Text on Back shirt'
                onFocus={props.amp_logFieldClick}
                onChange={props.handleTextInputChange}
            />
        </Form.Field>
        : ''

    //this.state.orderList.map((order) =>
    const singleOrderArray = getSingleOrderArray().map((singelOrder, index) =>

        <SizeAndQtyFields
            handleOrderDetailsDropDownChanges={props.handleOrderDetailsDropDownChangesOrderOne}
            handleTextInputChange={props.handleTextInputChange}
            shirtColor={props.shirtColor1}
            shirtSize={props.shirtSize1}
            shirtType={props.shirtType1}
            qty={props.qty1}
            qtyTextFeildName={'qty1'}
            topDividerText={'Order ' + (index + 1)}
            visible={true}
            handleAddMoreClick={props.handleAddMoreClick}
            formErrorFieldArray={props.formErrorFieldArray}
            order2Visible={props.order2Visible}
            order3Visible={props.order3Visible}
            itemSelected={props.itemSelected}
            jerseyNumberFieldName={'jerseyNumber1'}
            jerseyNameFieldName={'jerseyName1'}
            jerseyNumber={props.jerseyNumber1}
            jerseyName={props.jerseyName1}
            //FOOTBACLL
            teamSelection={props.teamSelection1}
            selectedTeamColors={props.selectedTeamColors1}
            shirtColors={props.shirtColors1}
            typedInTeamNameFieldName={'typedInTeamName1'}
            typedInTeamName={props.typedInTeamName1}
            //SHIRT COLORS
            shirtSizes={props.shirtSizes}
            //CHILD
            childsAgeTextFeildName={'childsAge1'}
            //WORDS ON ITEM
            wordsOnItemLabel={props.wordsOnItemLabel}
        />

    )

    /**
     * SHOW THE PRICE OF THE FAMILY PACKAGE
     */

    const footballPackages = props.itemSelected === 'football' || props.itemSelected === 'cranes'
        ? <div>
            <Header as='h3' color='blue' textAlign='center'>
                {' '}** Jersey Packages **
    <br />
                {' '}Order the CHRISTMAS PACKAGE, get 5 jerseys for just  165,000 UGX
        <br />
                {' '}** OR **
    <br />
                {' '}Order the CHRISTMAS FRIENDS PACKAGE, get 3 jerseys for just  110,000 UGX
</Header>
        </div>
        : ''

    const replacementReason = props.replacement === 'yes'
        ?
        <Select
            value={props.replacementReason}
            options={props.replacementReasonOptions}
            onChange={props.handleOrderDetailsDropDownChanges}
            searchable={false}
            clearable={false}
        />
        : ''


    /**
     * UI FOR REPLACEMENT & ORDER SOURCE
     */
    const adminOrderEntryOptions = props.admin
        ? <div>

            {/* NEW ORDER SMS */}
            <Label pointing='below' color='blue'>{'SEND SMS?'}</Label>
            <Select
                name="form-field-name"
                value={props.sendNewOrderSms}
                options={props.sendNewOrderSmsOptions}
                onChange={props.handleOrderDetailsDropDownChanges}
                searchable={false}
                clearable={false}
            />

            {/* REPLACEMENT */}
            {/* <Label pointing='below' color='blue'>{'REPLACEMENT ORDER?'}</Label>
            <Select
                name="form-field-name"
                value={props.replacement}
                options={props.replacementOptions}
                onChange={props.handleOrderDetailsDropDownChanges}
                searchable={false}
                clearable={false}
            />
            <br /> */}

            {/* REPLACEMENT REASON */}
            {/* {replacementReason} */}

            {/* ORDER SOURCE */}
            {/* <Label pointing='below' color='blue'>{'ORDER SOURCE?'}</Label>
            <Select
                name="form-field-name"
                value={props.orderSource}
                options={props.orderSourceOptions}
                onChange={props.handleOrderDetailsDropDownChanges}
                searchable={false}
                clearable={false}
            /> */}

            <br />
            {/* REPLACEMENT */}
            {/* <Label pointing='below' color='blue'>{'GENDER'}</Label>
            <Select
                name="form-field-name"
                value={props.gender}
                options={props.genderOptions}
                onChange={props.handleOrderDetailsDropDownChanges}
                searchable={false}
                clearable={false}
            /> */}

        </div>
        : ''

    /**
 * UI FOR REPLACEMENT & ORDER SOURCE
 */
    const bringJersey = props.admin && (props.itemSelected === 'cranes' || props.itemSelected === 'football')
        ? <div>
            {/* REPLACEMENT */}
            <Label pointing='below' color='blue'>{'BRING JERSEY?'}</Label>
            <Select
                name="form-field-name"
                value={props.bringJersey}
                options={props.bringJerseyOptions}
                onChange={props.handleOrderDetailsDropDownChanges}
                searchable={false}
                clearable={false}
            />
            <br />
        </div>
        : ''

    /**
    * UI FOR REPLACEMENT & ORDER SOURCE
    */
    const pricingNotes = props.admin
        ? <Form.Field>
            <label>Any Special Pricing Notes </label>
            <Form.TextArea
                name={'pricing_notes'}
                value={props.pricing_notes}
                placeholder='Special Pricing:'
                onFocus={props.amp_logFieldClick}
                onChange={props.handleTextInputChange}
                error={props.formErrorFieldArray['pricing_notes']}
            />
        </Form.Field>
        : ''


    /**
 * UI FOR ORDER TYPE
 */
    const setOrderTypeDropdown = props.admin && props.itemSelected !== 'football' && props.itemSelected !== 'cranes'
        ? <div>
            {/* REPLACEMENT */}
            <Label pointing='below' color='blue'>{'ORDER TYPE?'}</Label>
            <Select
                name="form-field-name"
                value={props.orderType}
                options={props.orderTypeOptions}
                onChange={props.handleOrderDetailsDropDownChanges}
                searchable={false}
                clearable={false}
            />
            <br />
        </div>
        : ''

    // const setGenderDropdown = props.admin
    //     ? <div>
    //         {/* REPLACEMENT */}
    //         <Label pointing='below' color='blue'>{'GENDER'}</Label>
    //         <Select
    //             name="form-field-name"
    //             value={props.gender}
    //             options={props.genderOptions}
    //             onChange={props.handleOrderDetailsDropDownChanges}
    //             searchable={false}
    //             clearable={false}
    //         />
    //         <br />
    //     </div>
    //     : ''


    const sendDesignToSalesUi = props.algoliaUser && props.algoliaUser !='' && props.algoliaUser.sendDesignToSales
    ? <div>
        {/* REPLACEMENT */}
        <Label pointing='below' color='blue'>{'SEND DESIGN TO ??'}</Label>
        <Select
            name="form-field-name"
            value={props.sendDesignToSales}
            options={props.sendDesignToSalesOptions}
            onChange={props.handleOrderDetailsDropDownChanges}
            searchable={false}
            clearable={false}
        />
        <br />
    </div>
    : ''
 

    return (

        props.orderConfirming || props.orderComplete
            ? <h6></h6>
            :
            <div className='login-form'>

                <Grid
                    textAlign='center'
                    // style={{ height: '100%' }}
                    verticalAlign='middle' >
                    <Grid.Column style={{ maxWidth: 550 }}>
                        {/* CLOSURE */}
                        <Image src={require('../../images/printboda_logo.png')} />
                        {/* <Image src='https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/closureNotices%2FPrintboda%20-%20covid%20-%20closed_5_siteImage-min.jpg?alt=media&token=432231de-4ede-40dc-a04d-701aa9e58cfa' /> */}
                        <Header as='h2' color='blue' textAlign='center'>
                            {' '}Order your {props.itemTypeDescription} starting @ {props.itemPrice} UGX ea
                        </Header>

                        {/* SHOW FOOTBALL PACKAGES */}
                        <br /><br />
                        {/* {footballPackages} */}

                        <br />
                        <Button onClick={props.backHome} type='button' color='teal' fluid size='large'>BACK</Button>
                        <br />


                        <Form size='large' onSubmit={props.validateForm}>
                            <Segment stacked>

                                {/* WORDS ON SHIRT */}
                                {/* {wordsOnShirt} */}

                                {/* WORDS ON BACK OF SHIRT */}
                                {/* {wordsOnBackOfshirt} */}

                                <p></p>


                                {/* ------   ORDER TWO  ------- */}
                                {/* <p>colors 2:{props.shirtColor2}</p>
                                <p>size 2:{props.shirtSize2}</p>
                                <p>type 2:{props.shirtType2}</p>
                                <p>qty 2:{props.qty2}</p> */}
                                <SizeAndQtyFields
                                    handleOrderDetailsDropDownChanges={props.handleOrderDetailsDropDownChangesOrderTwo}
                                    handleTextInputChange={props.handleTextInputChange}
                                    shirtColor={props.shirtColor2}
                                    shirtSize={props.shirtSize2}
                                    shirtType={props.shirtType2}
                                    qty={props.qty2}
                                    qtyTextFeildName={'qty2'}
                                    topDividerText={'Order 2'}
                                    visible={props.order2Visible}
                                    handleAddMoreClick={props.handleAddMoreClick}
                                    formErrorFieldArray={props.formErrorFieldArray}
                                    order2Visible={props.order2Visible}
                                    order3Visible={props.order3Visible}
                                    itemSelected={props.itemSelected}
                                    jerseyNumberFieldName={'jerseyNumber2'}
                                    jerseyNameFieldName={'jerseyName2'}
                                    jerseyNumber={props.jerseyNumber2}
                                    jerseyName={props.jerseyName2}
                                    //FOOTBACLL
                                    teamSelection={props.teamSelection2}
                                    selectedTeamColors={props.selectedTeamColors2}
                                    shirtColors={props.shirtColors2}
                                    typedInTeamNameFieldName={'typedInTeamName2'}
                                    typedInTeamName={props.typedInTeamName2}
                                    shirtSizes={props.shirtSizes}
                                    childsAgeTextFeildName={'childsAge2'} />


                                <SingleOrderFromArray
                                    itemSelected={props.itemSelected} //done
                                    formErrorFieldArray={props.formErrorFieldArray}
                                    //UPDATE ORDER ARRAY
                                    updateSingleOrderArray={props.updateSingleOrderArray}
                                    wordsOnItemLabel={props.wordsOnItemLabel}
                                    admin={props.admin}
                                    cardObject={props.cardObject}
                                />
                                {imagePreview}


                                {/* NAME */}
                                <Form.Field>
                                    <label>Your Name</label>
                                    <Form.Input
                                        fluid
                                        name={'name'}
                                        value={props.name}
                                        icon='add user'
                                        iconPosition='left'
                                        placeholder='Name'
                                        onFocus={props.amp_logFieldClick}
                                        onChange={props.handleTextInputChange}
                                        error={props.formErrorFieldArray['name']}
                                    />
                                </Form.Field>

                                {/* PHONE */}
                                <Form.Field>
                                    <label>Phone #1 (Whatsapp)</label>
                                    <Form.Input
                                        fluid
                                        name={'phone'}
                                        value={props.phone}
                                        icon='phone'
                                        iconPosition='left'
                                        placeholder='Phone Number'
                                        onFocus={props.amp_logFieldClick}
                                        onChange={props.handleTextInputChange}
                                        control='input'
                                        type='number'
                                        length = '10'
                                        error={props.formErrorFieldArray['phone']}
                                    />
                                </Form.Field>

                                {/* PHONE #2 */}
                                <Form.Field>
                                    <label>Phone #2</label>
                                    <Form.Input
                                        fluid
                                        name={'phone2'}
                                        value={props.phone2}
                                        icon='phone'
                                        iconPosition='left'
                                        placeholder='Phone Number #2'
                                        onFocus={props.amp_logFieldClick}
                                        onChange={props.handleTextInputChange}
                                        control='input'
                                        type='number'
                                        error={props.formErrorFieldArray['phone2']}
                                    />
                                </Form.Field>

                                {/* EMAIL */}
                                <Form.Field>
                                    <label>Email</label>
                                    <Form.Input
                                        fluid
                                        name={'email'}
                                        value={props.email}
                                        icon='user'
                                        iconPosition='left'
                                        placeholder='Email'
                                        onFocus={props.amp_logFieldClick}
                                        onChange={props.handleTextInputChange}
                                        control='input'
                                        type='email'
                                    />
                                </Form.Field>

                                {/* DELIVERY ADDRESS */}
                                <Form.Field>
                                    <label>Printboda Makes Delivery During Work Hours, Please give your work address if available</label>
                                    <label>Full Delivery Address:(Street or Road, Plot Number, Building, Any landmarks) </label>
                                    <Form.TextArea
                                        name={'address'}
                                        value={props.address}
                                        placeholder='Full Delivery Address:'
                                        onFocus={props.amp_logFieldClick}
                                        onChange={props.handleTextInputChange}
                                        error={props.formErrorFieldArray['address']}
                                    />
                                </Form.Field>


                                {/* SPECIAL DIRECTIONS */}
                                <Form.Field>
                                    <label>Any Special Instructions for your order? </label>
                                    <Form.TextArea
                                        name={'special_instructions'}
                                        value={props.special_instructions}
                                        placeholder='Special Instructions:'
                                        onFocus={props.amp_logFieldClick}
                                        onChange={props.handleTextInputChange}
                                        error={props.formErrorFieldArray['special_instructions']}
                                    />
                                </Form.Field>

                                {/* coupon */}
                                <Form.Field>
                                    <label>Enter Discount Code (Optional - Only if you have a discount code to use for your order?)</label>
                                    <Form.Input
                                        fluid
                                        name={'couponCode'}
                                        value={props.couponCode}
                                        icon='money'
                                        iconPosition='left'
                                        placeholder='Coupon / Discount Coude'
                                        onFocus={props.amp_logFieldClick}
                                        onChange={props.handleTextInputChange}
                                        control='input'
                                        type='text'
                                    />
                                </Form.Field>

                                {pricingNotes}

                                {/* REPLACEMENT */}
                                {adminOrderEntryOptions}

                                {sendDesignToSalesUi}

                                {/* BRING JERSEY */}
                                {/* {bringJersey} */}

                                {/* SET ORDER TYPE */}
                                {/* {setOrderTypeDropdown} */}

                                {/* SET GENDER TYPE */}
                                {/* {setGenderDropdown} */}

                             

                                <br />
                                <Button color='blue' fluid size='large'>ORDER</Button>
                                <br />
                                <ErrorMessages
                                    formHasError={props.formHasError}
                                    formErrors={props.formErrors} />

                                <Button onClick={props.cancelOrder} type='button' color='red' fluid size='large'>CANCEL</Button>

                            </Segment>
                        </Form>
                        {/* <Message>
                            New to us? <a href='#'>Sign Up</a>
                        </Message> */}
                    </Grid.Column>
                </Grid>
            </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/newSite/OrderFormUI.js